function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.1",
  width: "33",
  height: "31.001",
  id: "svg41",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.39 1.155h23.548v6.137l-2.452.016a3931.735 3931.735 0 00-3.976.028 1951.975 1951.975 0 00-3.766.026l-.316.001-.289.003-.25.001c-.243.007-.243.007-.556.1l.28.078c2.147.613 3.533 1.541 4.59 3.108.397.753.378 1.936-.025 2.688-.816 1.452-2.009 2.47-3.944 3.069-.794.223-1.499.3-2.34.293h-.35c-.379 0-.756-.002-1.134-.004l-.791-.001c-.691-.001-1.382-.004-2.073-.007-.706-.003-1.413-.004-2.119-.005-1.383-.003-2.767-.007-4.15-.013l-.323-.621-.09-.175c-1.509-2.92-1.108-5.746.413-8.585l.112-6.137z",
  fill: "#edaf43",
  id: "path2",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.153 7.271h.29l.313.001h.334l1.09.003h.756l1.99.005 2.03.004c1.327.001 2.655.004 3.982.008l.329.506.185.284c.297.478.45.976.613 1.49l.103.282c.834 2.531-.02 5.306-1.68 7.52-1.94 2.445-4.936 4.191-8.458 5.025l-.257.061c-.286.064-.573.12-.863.175l-.356.068c-1.396.235-2.764.228-4.186.22h-.78c-.679-.001-1.358-.004-2.036-.007l-2.453-.006c-1.237-.003-2.473-.008-3.71-.013v-6.224l2.516-.007 1.584-.007c.836-.004 1.673-.008 2.51-.01.675-.001 1.35-.004 2.025-.01l.77-.001c1.883.016 1.883.016 3.666-.404l.224-.078c1.777-.645 2.742-1.602 3.494-2.99.353-1.201.159-2.301-.67-3.346-.925-1.023-2.025-1.62-3.499-2.09l-.486-.165-.303-.099c.326-.144.559-.197.933-.196z",
  fill: "#0e4cbd",
  id: "path3",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.023 7.994c.359.157.687.331 1.014.526l.252.146c.954.6 1.939 1.605 2.114 2.571.11 1.393-.214 2.61-1.38 3.716-1 .812-2.47 1.581-3.948 1.65-1.434-.06-2.84-.887-3.784-1.672-.888-.848-1.434-1.837-1.423-2.932l.002-.22c.023-.63.212-1.131.618-1.681l.152-.212c1.451-1.838 3.836-2.863 6.383-1.892z",
  fill: "#fefefe",
  id: "path4",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.826 16.76h.112v6.138h-11.83v-.088l.217-.032c2.986-.443 5.663-1.124 8.008-2.686l.173-.112c1.307-.857 2.295-1.869 3.155-3.013l.165-.206z",
  fill: "#eb9c46",
  id: "path5",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.39 1.155h11.492v.088l-.311.036c-3.964.512-7.617 2.047-10.048 4.578l-.157.161c-.353.378-.561.744-.751 1.187h-.226v-6.05z",
  fill: "#1a4480",
  id: "path6",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.178 27.155l.27-.009c.464-.003.776.019 1.146.247.472.39.565.656.55 1.181-.075.404-.429.732-.825.987-.387.1-.699.105-1.106.11l-.41.006c-.58-.042-.944-.184-1.343-.51-.257-.43-.272-.806-.183-1.272.441-.7.982-.734 1.901-.74z",
  fill: "#000",
  id: "path7",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.875 24.23c.338.195.526.303.726.597.082.464.132.958-.198 1.37-.378.31-.586.375-1.143.413-.168.002-.336.003-.505.003l-.253.007c-.592.003-.926-.087-1.394-.39-.341-.39-.44-.765-.338-1.228.159-.37.362-.568.781-.784.73-.197 1.6-.176 2.324.011z",
  fill: "#000",
  id: "path8",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.762 24.23c.477.275.688.476.831.93.038.387-.046.747-.33 1.07-.542.358-.954.405-1.634.394-.083 0-.166.003-.25.004-.583-.003-.927-.096-1.384-.399-.327-.37-.4-.8-.298-1.237.158-.362.449-.618.892-.792a4.6 4.6 0 012.173.03z",
  fill: "#000",
  id: "path9",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.826 16.76h.112a130.091 130.091 0 01.01.802c.002.356-.011.694-.122 1.04-.38.289-.786.491-1.24.701-.228.13-.453.264-.679.397-.291.17-.595.323-.898.48-.228.132-.455.266-.682.4-.29.167-.594.32-.895.477-.096.06-.191.12-.29.18-.274.17-.274.17-.534.291a9.977 9.977 0 00-1.864 1.158c-.54.277-1.27.222-1.896.22h-.24l-.747-.003h-.51l-1.243-.005v-.088l.217-.031c2.986-.444 5.663-1.125 8.008-2.686l.173-.113c1.307-.856 2.295-1.869 3.155-3.013l.165-.206z",
  fill: "#c48e3f",
  id: "path10",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.009 27.106c.207 0 .207 0 .45.088.158.201.285.39.41.603.273.455.273.455.605.887l.164-.3.216-.39.108-.198.106-.19.097-.176c.098-.149.098-.149.323-.324.24.033.24.033.45.088a370.527 370.527 0 01.617 1.686l.1.275c.072.23.072.23.072.494h-.676l-.563-1.403-.789 1.403h-.563l-.789-1.315c-.19.295-.302.539-.408.854l-.09.262-.065.199h-.676c.077-.54.255-1.046.45-1.567l.094-.256c.23-.62.23-.62.357-.72z",
  fill: "#000",
  id: "path11",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.284 27.177l.334.004c.271.003.542.007.813.013v.439l-.374.016-.492.022-.246.01c-.428.02-.835.05-1.254.127-.135.315-.15.546-.112.877.258.278.4.343.84.404l.427.012.431.015.33.007v-.526h-1.465v-.438h2.14v1.49c-.377.01-.755.017-1.133.022l-.322.009c-.708.008-1.124-.053-1.7-.381-.382-.414-.42-.823-.337-1.316.135-.298.248-.466.556-.67.517-.177 1.006-.146 1.564-.135z",
  fill: "#000",
  id: "path12",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.939 24.125l1.253-.016.391-.007c.623-.004 1.092.002 1.623.287.29.334.236.66.168 1.043-.068.227-.183.37-.393.535l.676.613c-.33.027-.58.047-.902 0-.166-.114-.166-.114-.316-.257-.226-.208-.33-.263-.677-.323-.308-.02-.613-.033-.922-.033v-.439l1.803-.087v-.614c-.237-.184-.749-.125-1.078-.137l-.95-.038v1.928h-.676v-2.454z",
  fill: "#000",
  id: "path13",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.947 24.117a178.564 178.564 0 01.717.003h.37l.904.005v.526l-2.478.087-.113.351.2.003c.3.005.599.012.899.02.103 0 .207.003.314.004.765.021.765.021 1.134.22.165.202.218.305.213.543l.004.175c-.088.258-.245.36-.51.526-.32.04-.32.04-.685.034l-.396-.003-.412-.009-.417-.005c-.34-.004-.68-.01-1.02-.017v-.438l2.705-.088v-.438l-.424.009-.555.007-.28.007c-.537.005-.897-.01-1.333-.286-.179-.279-.158-.574-.113-.877.315-.36.754-.361 1.276-.36z",
  fill: "#000",
  id: "path14",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.939 24.125c.472.045.697.147 1.037.403l.256.191.263.2.269.202c.219.164.436.33.653.495l.113-1.49h.676c.007.39.01.781.014 1.172l.006.338.002.321.004.298c-.025.237-.025.237-.25.413-.424-.024-.627-.194-.914-.423l-.258-.202-.265-.214-.271-.214-.659-.525-.113 1.49h-.676l-.007-1.129a1173.695 1173.695 0 01-.004-.635c0-.094 0-.189-.002-.286.013-.23.013-.23.126-.405z",
  fill: "#000",
  id: "path15",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.67 27.106c.485.033.704.155 1.038.422l.257.203.262.213.27.215.653.525.112-1.578h.564v2.455l-.564.088c-.25-.135-.25-.135-.498-.337l-.272-.217-.279-.23-.285-.23a87.488 87.488 0 01-.694-.564l-.112 1.578h-.564l-.006-1.044c0-.119 0-.237-.002-.356l-.003-.51c0-.102 0-.204-.002-.31.013-.235.013-.235.126-.323z",
  fill: "#000",
  id: "path16",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.953 27.194l1.373-.028.43-.012c.922-.009.922-.009 1.381.233.204.256.272.386.266.683l.004.22c-.112.33-.285.456-.638.657-.335.051-.654.042-.993.028l-.269-.006a41.854 41.854 0 01-.653-.022v-.438l.308-.01c.2-.01.2-.01.403-.018l.4-.015c.35-.023.35-.023.57-.169.146-.137.146-.137.107-.325l-.098-.165c-.39-.1-.737-.116-1.148-.137l-.768-.038v2.016h-.676v-2.454z",
  fill: "#000",
  id: "path17",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.558 27.194h.676l.013.336.022.436.008.222.013.213.009.196c.061.221.16.3.386.438.546.125.936.065 1.465-.088.126-.196.135-.32.148-.537l.015-.215.013-.223.015-.226.034-.552h.676c.01.25.016.5.022.75l.009.213c.008.477-.049.815-.368 1.229-.686.37-1.452.33-2.254.263-.388-.101-.601-.247-.803-.53-.141-.374-.122-.732-.112-1.12l.003-.235.01-.57z",
  fill: "#000",
  id: "path18",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.247 27.177a1694.43 1694.43 0 00.65.006l.335.002.82.009v.438l-.375.013-.492.02-.246.008c-.455.02-.848.044-1.254.222-.189.287-.189.287-.225.614.146.262.232.397.563.526.155.013.31.021.466.027l.275.011.287.01c.096.005.192.009.29.012l.71.027v.526c-.342.007-.685.013-1.028.017l-.292.007c-.587.005-.99-.03-1.497-.287-.39-.32-.484-.578-.507-1.008.021-.428.125-.686.507-1.008.347-.168.607-.196 1.013-.192z",
  fill: "#000",
  id: "path19",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.58 24.109l.282.004c.227.003.455.008.682.013v.526l-.428.007-.558.015-.281.004c-.563.017-.563.017-1.048.225-.223.256-.22.41-.164.713.2.275.285.337.676.439a39.434 39.434 0 001.179.06l.624.028v.438c-.38.013-.76.02-1.14.027l-.325.011c-.897.012-.897.012-1.306-.246-.44-.374-.552-.678-.531-1.19.06-.31.197-.572.485-.794.63-.27 1.144-.297 1.852-.28z",
  fill: "#000",
  id: "path20",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.039 24.618c.322.033.322.033.681.176.257.261.326.404.317.734-.337.497-.337.497-.789.614-.606.046-1.086.05-1.577-.263-.225-.263-.225-.263-.211-.565.22-.7.751-.72 1.579-.696z",
  fill: "#fff",
  id: "path21",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.248 24.651c.417.169.526.265.676.609 0 .323-.078.456-.338.706-.475.226-.922.225-1.464.176-.335-.111-.5-.199-.719-.422-.1-.275-.067-.445.043-.718.465-.458 1.112-.43 1.802-.35z",
  fill: "#fff",
  id: "path22",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.967 27.747c.32.199.452.347.514.663-.05.274-.05.274-.247.526-.554.283-1.074.26-1.718.187-.366-.132-.366-.132-.563-.351a1.181 1.181 0 010-.701c.489-.512 1.294-.58 2.014-.324z",
  fill: "#fff",
  id: "path23",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.826 16.76h.112a130.091 130.091 0 01.01.802c.002.356-.011.694-.122 1.04-.38.289-.786.491-1.24.701a35.58 35.58 0 00-.45.263c-.659.388-.659.388-1.014.526l-.226-.087c.065-.29.164-.415.444-.609.942-.704 1.658-1.554 2.317-2.426l.169-.21z",
  fill: "#cd823a",
  id: "path24",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.164 27.194h3.042v.438h-1.24v2.017h-.563v-2.017h-1.24v-.438z",
  fill: "#000",
  id: "path25",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.431 27.194h.677v2.455h-.677v-2.455z",
  fill: "#000",
  id: "path26",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.544 24.125h.676v2.455h-.676v-2.455z",
  fill: "#000",
  id: "path27",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.826 16.76h.112v1.316l-.345.142c-.401.176-.716.39-1.043.64-.189.095-.189.095-.438.066l-.202-.06c.047-.036.093-.074.141-.112.627-.528 1.08-1.114 1.55-1.728l.225-.263z",
  fill: "#a66c38",
  id: "path28",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.39 22.109c-.408.213-.818.418-1.24.614l-.338.175c-.287.02-.287.02-.625.017l-.366-.002-.382-.004-.387-.002c-.315-.002-.63-.005-.944-.01v-.087l.226-.034c1.832-.27 1.832-.27 3.607-.702.223-.053.223-.053.448.035z",
  fill: "#a08646",
  id: "path29",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.826 18.076v.263c-.202.15-.202.15-.472.307l-.28.162c-.268.148-.542.28-.826.408l-.225.175-.275.082a1.481 1.481 0 00-.626.356l-.226-.087c.156-.129.314-.257.472-.384l.265-.216c.282-.193.495-.262.84-.365.2-.116.395-.236.585-.361.518-.34.518-.34.768-.34z",
  fill: "#bc7736",
  id: "path30",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.178 21.67l.225.088-.648.428-.184.122c-.575.376-.89.529-1.647.502.249-.193.487-.298.79-.438.256-.133.512-.268.767-.403.229-.115.445-.219.697-.299z",
  fill: "#b38937",
  id: "path31",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.713 16.848h.113c.072.319.108.483 0 .79-.373.334-.791.605-1.24.876 0-.366.247-.588.5-.882.334-.382.334-.382.627-.784z",
  fill: "#905c32",
  id: "path32",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.657 3.96c.111.03.223.059.338.088-.276.22-.553.44-.831.658l-.239.19-.228.18-.211.167c-.181.12-.181.12-.407.12.187-.379.55-.622.916-.898l.192-.147c.156-.12.313-.239.47-.357z",
  fill: "#cea740",
  id: "path33",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.037 22.372c-.113.263-.113.263-.45.438-.379.017-.379.017-.81.011l-.435-.005-.333-.006c.37-.192.646-.244 1.077-.318l.395-.069c.33-.051.33-.051.556-.051z",
  fill: "#897336",
  id: "path34",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.009 1.139l.254.003c.207.003.413.008.62.013v.088l-.874.137-.25.04c-.417.064-.724.094-1.13-.002.41-.32.833-.294 1.38-.28z",
  fill: "#123778",
  id: "path35",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.324 22.043l.192.066c-.158.12-.318.238-.479.356-.133.1-.133.1-.27.2-.265.145-.265.145-.524.123l-.192-.065c.158-.12.318-.239.48-.357l.268-.2c.266-.145.266-.145.525-.123z",
  fill: "#d29d3b",
  id: "path36",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.431 21.057a8.417 8.417 0 01-1.577.789c.97-.947.97-.947 1.577-.79z",
  fill: "#d1943b",
  id: "path37",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.39 5.714h.112v1.052l.338-.087-.225.526h-.226v-1.49z",
  fill: "#354650",
  id: "path38",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.39 22.109c-.367.194-.724.381-1.128.526l.113-.176-.225-.175.493-.137.277-.077c.244-.049.244-.049.47.039z",
  fill: "#917843",
  id: "path39",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.305 21.232l.225.088c-.285.27-.589.343-1.014.438l-.113-.175.437-.181.246-.102.219-.068z",
  fill: "#b28744",
  id: "path40",
  strokeWidth: ".099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.854 1.243l1.014.087v.088l-1.24.088.226-.263z",
  fill: "#1a3562",
  id: "path41",
  strokeWidth: ".099"
})));